var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ratingNumber)?_c('span',{staticClass:"tag mr-1 is-rounded is-font-small",staticStyle:{"float":"right","width":"fit-content"},style:({ 'background-color': _vm.ratingColor, color: 'rgba(0,0,0,0.8)' })},[_vm._v("Bewertung: "+_vm._s(_vm.ratingNumber)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }